


import useSeo from "../services/useSeo";

export default function Contact() {
    useSeo({
        title: "聯絡我們 / 求譜專區 | 琴語鋼琴網",
        description: "聯絡琴語鋼琴網，或提出您的求譜與客製化製譜需求。",
        canonicalPath: "/contact",
    });
    return (
        <div>
        <img src="https://pianolangpic.s3.us-east-2.amazonaws.com/contact.png" className="img-fluid w-100" alt="Contact information" />
        </div>
    );
    }